function academic_transcript_icon(content_type) {
    if(content_type == "application/pdf"){
      return "<span class='fe fa-2x fe-file-text'></span>"
    }
    else {
      return "<span class='fe fa-2x fe-image'></span>"
    }
}

export default academic_transcript_icon;